export type spaceTokenNumberValue =
	| '0'
	| '025'
	| '050'
	| '075'
	| '100'
	| '150'
	| '200'
	| '250'
	| '300'
	| '400'
	| '500'
	| '600'
	| '800'
	| '1000';

export const spaceTokenValues: Record<string, spaceTokenNumberValue> = {
	'space.0': '0',
	'space.025': '025',
	'space.050': '050',
	'space.075': '075',
	'space.100': '100',
	'space.150': '150',
	'space.200': '200',
	'space.250': '250',
	'space.300': '300',
	'space.400': '400',
	'space.500': '500',
	'space.600': '600',
	'space.800': '800',
	'space.1000': '1000',
};
